exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".border {\n    border: 1px solid black;\n}\n\n.progress-bar {\n  border: 1px solid #2f9987;\n  border-top-left-radius: 4px;\n  border-bottom-left-radius: 4px;\n  background-color: #38b6a0;\n  background-repeat: no-repeat;\n}\n\n.small-black-font {\n  font-family: 'Open Sans', sans-serif;\n  font-size: 14px;\n  color: #26273b;\n}\n\n.padding-top-16 {\n  padding-top: 16px;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/core/components/workflow-new/common/banner-card/banner-card.component.css
// module id = 811
// module chunks = 0